// 菜单配置
// headerMenuConfig：头部导航配置
// asideMenuConfig：侧边导航配置 (支持 children 二级分组, Aside.toMenuItems 已兼容)

const headerMenuConfig = [];

// ICON 配置： https://ice.alibaba-inc.com/component/foundationsymbol
const asideMenuConfig = [
  {
    name: '仪表盘',
    path: '/dashboard',
    icon: 'chart-pie',
  },
  {
    name: '智能问答 ✨',
    path: '/AgentChat',
    icon: 'help',
  },
  {
    name: '合同管理',
    icon: 'favorites-filling',
    children: [
      { name: '合同管理', path: '/contractManage' },
      { name: '坏账合同列表', path: '/BadDebtContractList' },
      { name: '合同项目分析', path: '/contractDashboard' },
      { name: '合同税率明细', path: '/ContractTaxBreakdown' },
      { name: '合同未收款提醒', path: '/UnpaidReminder' },
    ],
  },
  {
    name: '开票收款',
    icon: 'chart-pie',
    children: [
      { name: '开票记录列表', path: '/ContractInvoiceList' },
      { name: '收款记录列表', path: '/ContractReceiveAmountList' },
    ],
  },
  {
    name: '项目采购',
    icon: 'chart-bar',
    children: [
      { name: '零星项目管理', path: '/ProjectList' },
      { name: '项目采购审批', path: '/Approval' },
      { name: '项目采购成本汇总', path: '/ProjectCostReport' },
      { name: '个人采购管理', path: '/PersonalApproval' },
    ],
  },
  {
    name: '采购合同',
    icon: 'atm',
    children: [
      { name: '采购合同管理', path: '/PurchaseContractList' },
      { name: '来票未收提示', path: '/PurchaseInvoiceReminder' },
      { name: '财务付款', path: '/FinancePayment' },
      { name: '机动来票库', path: '/SupplierInvoiceLibrary' },
      { name: '入库单打印', path: '/InvoiceWarehousePrint' },
      { name: '来票/已开票比对', path: '/InvoiceComparison' },
    ],
  },
  {
    name: '库存管理',
    path: '/StockManage',
    icon: 'application',
  },
  {
    name: '员工管理',
    icon: 'account',
    children: [
      { name: '员工合同', path: '/EmployeeContract' },
    ],
  },
  {
    name: '公司管理',
    icon: 'building',
    children: [
      { name: '固定资产合同', path: '/CompanyFixedAssetContracts' },
      { name: '日常合同', path: '/CompanyDailyContracts' },
      { name: '费用发票', path: '/CompanyExpenseInvoices' },
      { name: '资料管理', path: '/DocumentLibrary' },
    ],
  },
  {
    name: '系统设置',
    icon: 'set',
    children: [
      { name: '用户管理', path: '/users' },
      { name: '角色权限管理', path: '/RoleManage' },
      { name: '主体公司管理', path: '/MainCompanyManage' },
      { name: '数据字典', path: '/DataDictionary' },
      { name: '供应商管理', path: '/Provider' },
      { name: '数据巡检', path: '/DataInspect' },
    ],
  },
];

// 供应商角色 (userType=4) 看到的菜单
const asideMenuConfig2 = [
  {
    name: '报价列表',
    path: '/ProviderList',
    icon: 'attachment',
  },
];

// 采购角色 (userType=3) 暂无独立菜单
const asideMenuConfig3 = [];

// 财务角色 (userType=5) 菜单
const asideMenuConfig4 = [
  {
    name: '合同管理',
    icon: 'favorites-filling',
    children: [
      { name: '合同管理', path: '/contractManage' },
      { name: '坏账合同列表', path: '/BadDebtContractList' },
      { name: '合同项目分析', path: '/contractDashboard' },
    ],
  },
  {
    name: '开票收款',
    icon: 'chart-pie',
    children: [
      { name: '开票记录列表', path: '/ContractInvoiceList' },
      { name: '收款记录列表', path: '/ContractReceiveAmountList' },
    ],
  },
  {
    name: '公司管理',
    icon: 'building',
    children: [
      { name: '资料管理', path: '/DocumentLibrary' },
    ],
  },
  {
    name: '财务付款',
    path: '/FinancePayment',
    icon: 'atm',
  },
];

export { headerMenuConfig, asideMenuConfig, asideMenuConfig2, asideMenuConfig3, asideMenuConfig4 };
